module.exports = __webpack_public_path__ + "img/pro_three_1.abc6bc68.jpg";